<template>
  <d-list-group flush>
    <d-list-group-item class="p-3">
      <d-row>
        <d-col>
          <d-form @submit.prevent="save" :validated="hasErrors">
            <d-row>
              <d-col md="12" class="form-group">
                <d-form-row>
                  <!-- Estado -->
                  <d-col md="2" class="form">
                    <label for="feInputState">Estado</label>
                    <select-state
                      id="feInputState"
                      :model.sync="model.state"
                      :onChange="getCities"
                      :validate="hasErrorField('state')"
                    />
                    <d-form-invalid-feedback>
                      Estado é obrigatório
                    </d-form-invalid-feedback>
                  </d-col>
                  <!-- Cidade -->
                  <d-col class="form-group">
                    <label for="feInputCity">Cidade</label>
                    <autocomplete
                      ref="autocomplete"
                      placeholder="Cidade"
                      :items="cities"
                      item-show="nome"
                      :on-input="onInput"
                      :on-select="saveSelectedCity"
                      :state="hasErrorField('city')"
                      :disabled="!model.state"
                      :textFeedback="'Cidade é obrigatória'"
                    />
                  </d-col>
                </d-form-row>
              </d-col>
            </d-row>
          </d-form>
          <d-row>
            <d-col cols="12">
              <div class="d-flex justify-content-end">
                <d-button class="btn-dark mr-2 btn-custom-size" @click="goBack">
                  Cancelar
                </d-button>
                <d-button @click="save" class="btn-accent btn-custom-size">
                  Salvar
                </d-button>
              </div>
            </d-col>
          </d-row>
        </d-col>
      </d-row>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import mixin from '_common/mixins/ValidateForm';
import { CloneDeep, getCitiesByState } from '_utils';
import SelectState from '_shared/SelectState.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import { MODEL, _LOAD_MODEL_ } from './RegionModel';

export default {
  name: 'region-form',
  mixins: [mixin],
  components: {
    SelectState,
    Autocomplete,
  },
  data() {
    return {
      model: CloneDeep(MODEL),
      cities: [],
      errors: {
        city: { required: false },
        state: { required: false },
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions(['activeAlert', 'checkAdmin', 'toggleLoading', 'saveRegion']),
    getCities(state) {
      getCitiesByState(state).then(response => {
        this.cities = response;
      });
    },
    saveSelectedCity(city) {
      if (city) this.model.city = city.nome;
    },
    onInput(searchTerm) {
      if (searchTerm) {
        const filteredCities = this.cities.filter(city =>
          city.nome.toLowerCase().includes(searchTerm.toLowerCase())
        );
        if (filteredCities.length) {
          this.cities = filteredCities;
        }
      } else {
        this.getCities(this.model.state);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    save() {
      if (this.checkForm()) {
        return this.saveRegion(this.model)
          .then(response => {
            if (!this.$route.params.id) {
              this.$router.push(`/admin/regiao/${response.id}`);
            }
            this.setRegion(response);
            this.success();
          })
          .catch(error => {
            this.activeAlert({
              message: `${error.message} <br/> ${error.data}`,
              theme: 'danger',
            });
          });
      }

      return null;
    },
    success() {
      this.activeAlert({
        message: 'Região salva com sucesso',
        theme: 'success',
      });
    },
    setCity(city) {
      if (this.$refs.autocomplete && city) {
        this.$refs.autocomplete.$refs.input.value = city;
      }
    },
    setRegion(newValue) {
      this.model = {
        ...newValue,
      };
      setTimeout(() => {
        this.setCity(newValue.city);
      }, 10);
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_LOAD_MODEL_, this.setRegion);
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
};
</script>
